export default class extends Controller {
  static targets = ["input"]

  connect() {
    App.DynamicSelect.initEl(this.inputTarget)
    App.DynamicSelect.onChange(this.inputTarget, this.emitChangeEvent.bind(this))
  }

  emitChangeEvent() {
    dispatchCustomEvent("billing-category:change", this.element, { value: this.value })
  }

  get value() {
    return App.DynamicSelect.getValue(this.inputTarget)
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/assets/javascript/forms-billing-category-field-controller.js